import type { Key } from "react-stately";

export function redirectRoute(key: Key, tabKey: string): string {
  if (key === "view-all") return "/projects";
  if (key === "view") return "/projects/$projectId";
  if (key === "requests") return "/project-associated-requests/$projectId";

  return `/projects/$projectId/${tabKey}`;
}
